// extracted by mini-css-extract-plugin
export default {"split-button":"components-market-settings-central-mapping-tables-table-mapping-module__split-button"};